/** Textes « dettes » — le français fait foi. */
export const dettes = {
  filtres: { tout: 'Toutes', credit: 'À crédit', oubli: 'Non encaissées', rendue: 'Voiture rendue' },
  erreurChargement: 'Cette liste n\'a pas pu être chargée.',
  erreurTitre: 'Les dettes ne s\'affichent pas',
  titre: 'Dettes',
  nonSoldes: (n: number) => `${n} dossier(s) non soldé(s)`,
  nonRestituees: {
    titre: (n: number) => `${n} voiture(s) jamais restituée(s), et non payée(s)`,
    texte: 'La voiture n\'est pas revenue et l\'argent non plus. Prévenez un gérant tout de suite.',
  },
  rendues: {
    titre: (n: number) => `${n} voiture(s) rendue(s) sans que l'argent rentre`,
    texte: 'Tant que le client tient encore la voiture, vous avez un moyen de le relancer ; après, vous n\'avez plus que le téléphone.',
  },
  anciennes: {
    titre: (n: number, j: number) => `${n} dette(s) de plus de ${j} jours`,
    texte: 'La voiture est encore dehors, mais la location aurait dû être réglée.',
  },
  kpi: {
    total: 'Total dû', totalDetail: (n: number) => `sur ${n} dossier(s)`,
    credit: 'Accordé à crédit', creditDetail: 'le paiement différé était convenu au départ',
    nonEncaisse: 'Non encaissé', nonEncaisseDetail: 'pas encore encaissé au comptoir',
  },
  quiDoitQuoi: 'Qui doit quoi',
  videAucun: 'Personne ne vous doit rien',
  videFiltre: 'Aucune dette dans ce filtre',
  colonnes: {
    client: 'Client', voiture: 'Voiture', dossier: 'Dossier', fin: 'Fin de location',
    total: 'Total', encaisse: 'Encaissé', resteDu: 'Reste dû',
  },
  etat: {
    annulee: 'annulée — reste dû', credit: 'à crédit', tranches: 'solde de tranches',
    nonEncaissee: 'non encaissée', aVenir: 'location à venir',
    nonRendue: ' · voiture NON rendue', rendue: ' · voiture rendue', clos: ' · contrat clos',
  },
  retard: (n: number) => `${n} jour(s) de retard`,
  echueAujourdhui: 'échue aujourd\'hui',
  enCours: 'location en cours',
  encaisser: 'Encaisser',
  note: 'Le montant dû est le solde du contrat, recalculé depuis les mouvements de caisse : une dette ne peut jamais dire autre chose que la caisse. Elle disparaît d\'elle-même de cette liste dès que le solde est à zéro — il n\'y a rien à cocher.',
};
